<template>
<div>
  <div class="home-page">
    <div class="container">
      <div class="header-title">24小时实时数据</div>
      <div class="header-content">
        <div class="header-content-left">
          <span>{{year}}年{{month}}月{{date}}日</span>
          <span class="header-day">{{day}}</span>
          <span>{{hour}}:{{minute}}:{{second}}</span>
        </div>
        <div class="header-content-right">
          <span class="monitor">当前监控公司<span class="monitor-num">{{number}}</span>家</span>
            <router-link to="/companies">
              <div class="button">
                管理监控公司
              </div>
            </router-link>
            <router-link to="/bulletin-page">
              <div class="button">
                舆情简报
              </div>
            </router-link>
        </div>
      </div>
      <div class="news-count-card">
        <HomeNewsCountList></HomeNewsCountList>
      </div>
      <div class="center">
        <div class="center-content monitor-company">
          <HomeMonitorRanking></HomeMonitorRanking>
        </div>
        <div class="center-content news-risk">
          <HomeNewsDistribution></HomeNewsDistribution>
        </div>
        <div class="center-content current-time-news">
          <HomeCurrentNews></HomeCurrentNews>
        </div>
      </div>
      <div class="hot-event">
        <HomeHotEventList></HomeHotEventList>
      </div>
    </div>
    <PageFooter></PageFooter>
  </div>
</div>
</template>

<script>
import PageFooter from '@/components/common/PageFooter';
import HomeMonitorRanking from '@/components/news-monitor/HomeMonitorRanking';
import HomeCurrentNews from '@/components/news-monitor/HomeCurrentNews';
import HomeHotEventList from '@/components/news-monitor/HomeHotEventList';
import HomeNewsCountList from '@/components/news-monitor/HomeNewsCountList';
import HomeNewsDistribution from '@/components/news-monitor/HomeNewsDistribution';
import QuestionQuery from '@/rest/questionQuery';
import authService from '@/services/authService';

export default {
  data() {
    return {
      number: 0,
      username: '',
      noData: false,
      timer: null,
      year: 2019,
      month: 0,
      date: 0,
      Date: new Date(),
      day: 0,
      hour: 0,
      minute: 0,
      second: 0,
      weekday: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
    };
  },
  methods: {
    getYearMonthDayDate() {
      this.year = new Date().getFullYear();
      this.month = new Date().getMonth() + 1;
      this.date = (new Date().getDate() < 10) ? `0${new Date().getDate()}` : new Date().getDate();
      this.day = this.weekday[new Date().getDay()];
    },
    getHomeMonitorStatistics() {
      QuestionQuery.homeMonitorStatistics(this.username).then(res => {
        this.number = res.number;
      });
    }
  },
  watch: {
    hour(val) {
      if (!val) {
        this.getYearMonthDayDate();
      }
    }
  },
  components: {
    PageFooter,
    HomeMonitorRanking,
    HomeHotEventList,
    HomeCurrentNews,
    HomeNewsCountList,
    HomeNewsDistribution
  },
  created() {
    this.$nextTick(() => document.querySelector('.header-content').scrollIntoView({ block: 'center' }));
    // eslint-disable-next-line
    const _this = this;
    this.timer = window.setInterval(() => {
      _this.hour = new Date().getHours();
      _this.minute = (new Date().getMinutes() < 10) ? `0${new Date().getMinutes()}` : new Date().getMinutes();
      _this.second = (new Date().getSeconds() < 10) ? `0${new Date().getSeconds()}` : new Date().getSeconds();
    }, 1000);
  },
  mounted() {
    this.username = authService.getLoggedUserName();
    this.getYearMonthDayDate();
    this.getHomeMonitorStatistics();
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);        
    }
  }
};
</script>

<style lang="scss" scoped>
  .home-page {
    overflow: auto;
    width: 100%;
    min-height: 100%;
    background: #333138;
    .container {
      margin: 0 auto;
      padding: 25px 56px 0;
      max-width: 1680px;
      min-width: 1096px;
      .header-title {
        font-size: 24px;
        color: #ffffff;
      }
      .header-content {
        display: flex;
        justify-content: space-between;
        .header-content-left {
          padding-top: 7px;
          font-size: 14px;
          color: #ffffff;
          .header-day {
            margin: 0 24px;
          }
        }
        .header-content-right {
          .monitor {
            color: #ffffff;
            font-size: 14px;
            .monitor-num {
              color: #45a8cc;
            }
          }
          .button {
            display: inline-block;
            margin-left: 16px;
            height: 32px;
            line-height: 32px;
            width: 116px;
            text-align: center;
            font-size: 14px;
            border-radius: 4px;
            color: rgba(255, 255, 255, 0.8);
            background-color: rgba(255, 255, 255, 0.08);
            cursor: pointer;
            &:hover {
            }
            &:active {
            }
          }
        }
      }
      .news-count-card {
        padding: 24px 0 40px;
      }
      .center {
        display: flex;
        .center-content {
          flex: 1;
        }
        .news-risk {
          margin: 0 32px;
        
        }
      }
      .hot-event {
        padding: 40px 0;
      }
    }
  }
  a {
    text-decoration: none;
  }
</style>

